import { createStore } from 'vuex';

export default createStore({
  state: {
    Server_pubkey: '',
    Client_prikey: '',
    Signin_info: '',
    locale_setting: '',
    picture_Base64: '',
    shop_collection_cache: '',
    user_Info_cache: '',
    countryCode_cache: '',
    notMobileView: true
  },
  getters: {
    get_Server_pubkey: function(state) {
      return state.Server_pubkey;
    },
    get_Client_prikey: function(state) {
      return state.Client_prikey;
    },
    get_Signin_info: function(state) {
      if (!state.Signin_info) {
        state.Signin_info = sessionStorage.getItem('Signin_info');
      }
      return state.Signin_info;
    },
    get_locale_setting: function(state) {
      if (!state.locale_setting) {
        state.locale_setting = localStorage.getItem('locale_setting');
      }
      return state.locale_setting;
    },
    get_Server_pictureBase64: function(state) {
      if (!state.picture_Base64) {
        const cached = sessionStorage.getItem('picture_Base64_cache');
        if (!cached) return '';
        state.picture_Base64 = cached;
      }
      return state.picture_Base64;
    },
    get_shop_collection_cache: function(state) {
      if (!state.shop_collection_cache) {
        state.shop_collection_cache = sessionStorage.getItem(
          'shop_collection_cache'
        );
      }
      return state.shop_collection_cache;
    },
    get_user_Info_cache: function(state) {
      if (!state.user_Info_cache) {
        const cached = sessionStorage.getItem('user_Info_cache');
        if (!cached) return null;
        state.user_Info_cache = cached;
      }
      try {
        return JSON.parse(state.user_Info_cache);
      } catch (e) {
        console.error('[Store] Failed to parse user_Info_cache:', e);
        return null;
      }
    },
    get_CountryCode_cache: function(state) {
      if (!state.countryCode_cache) {
        const cached = sessionStorage.getItem('countryCode_cache');
        if (!cached) return null;
        state.countryCode_cache = cached;
      }
      try {
        return JSON.parse(state.countryCode_cache);
      } catch (e) {
        console.error('[Store] Failed to parse countryCode_cache:', e);
        return null;
      }
    },
    get_notMobileView: function(state) {
      return state.notMobileView;
    }
  },
  mutations: {
    set_Server_pubkey: function(state, serverPubkey) {
      state.Server_pubkey = serverPubkey;
    },
    set_Client_prikey: function(state, clientPrikey) {
      state.Client_prikey = clientPrikey;
    },
    set_Signin_info: function(state, signinInfo) {
      state.Signin_info = signinInfo;
      sessionStorage.setItem('Signin_info', signinInfo);
    },
    set_locale_setting: function(state, localeSetting) {
      state.locale_setting = localeSetting;
      localStorage.setItem('locale_setting', localeSetting);
    },
    set_Server_pictureBase64: function(state, picture) {
      state.picture_Base64 = picture;
      sessionStorage.setItem('picture_Base64_cache', picture);
    },
    set_shop_collection_cache: function(state, shopCollection) {
      state.shop_collection_cache = JSON.stringify(shopCollection);
      sessionStorage.setItem(
        'shop_collection_cache',
        JSON.stringify(shopCollection)
      );
    },
    set_user_Info_cache: function(state, userInfo) {
      state.user_Info_cache = JSON.stringify(userInfo);
      sessionStorage.setItem('user_Info_cache', JSON.stringify(userInfo));
    },
    set_CountryCode_cache: function(state, countryCode) {
      state.countryCode_cache = JSON.stringify(countryCode);
      sessionStorage.setItem('countryCode_cache', JSON.stringify(countryCode));
    },
    set_notMobileView: function(state, notMobileView) {
      state.notMobileView = notMobileView;
    }
  },
  actions: {
    async setServerpubkey({ commit }, serverPubkey) {
      commit('set_Server_pubkey', serverPubkey);
    },
    async setClientPrikey(context, clientPrikey) {
      context.commit('set_Client_prikey', clientPrikey);
    },
    async setSignininfo(context, signinInfo) {
      context.commit('set_Signin_info', signinInfo);
    },
    async setLocaleSetting(context, localeSetting) {
      context.commit('set_locale_setting', localeSetting);
    },
    async setServerpictureBase64(context, pictureBase64) {
      context.commit('set_Server_pictureBase64', pictureBase64);
    },
    async setShopCollectionCache(context, shopCollection) {
      context.commit('set_shop_collection_cache', shopCollection);
    },
    async setuserInfocache(context, userInfo) {
      context.commit('set_user_Info_cache', userInfo);
    },
    async setCountryCode(context, countryCode) {
      context.commit('set_CountryCode_cache', countryCode);
    },
    async setNotMobileView(context, notMobileView) {
      context.commit('set_notMobileView', notMobileView);
    }
  }
});
